export enum ELegalVisibility {
  PUBLIC = 'd90f05bf-5baf-4f86-9ca3-9501af6901ea',
  NON_PUBLIC = 'ae5de668-87ac-4650-af26-23dd0cb97c89',
}
